<template>
    <div>
       

       
        <div class="is-pulled-right " style="">
        
        <input class="input" v-model="search" placeholder="search bookings ..."/>
        
            </div>
        <div class="is-pulled-right mb-2"><input class="input" type="date" v-model="end_date" /></div>
        <div class="is-pulled-right mb-2"><input class="input" type="date" v-model="start_date" /></div>

        <div class="notification is-warning" v-if="loading == true"  style="clear:both">
            Loading bookings ...
        </div>
        <div class="notification is-danger" v-if="loading == false  && filtered_bookings.length == 0" style="clear:both">
            No bookings can be found matching your search criteria
        </div>

        <table class="table is-fullwidth is-striped is-hoverable is-size-7" v-if="loading == false && filtered_bookings.length > 0"  style="clear:both">
            <thead>
                <tr>
                        <th width="20"></th>
                        <th width="20">ID</th>
                    <th>Client</th>
                    <th>Ward</th>
                    <th>Reference</th>
                    <th>Grade</th>
                    <th>Member</th>
                    <th>Date</th>
                    <th>Time</th>
                    <th>Status</th>
                    
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in filtered_bookings" :key="row.id">
                    <td>
                        <span class="icon pointer" @click="showLogsModal(row.id)" >
                            <i class="fa fa-bars"></i>
                        </span>
                    </td>
                    <td><router-link :to="'/bookings/' + row.id">{{ row.id }} </router-link> </td>
                    <td>{{ getClientDisplayNameInternal(row) }} <span class="tag is-warning" v-if="row.sleeping_nurse==1">Sleeping Nurse</span> <span class="tag is-info mr-2" v-if="row.sleepover==1">Sleepover</span></td>
                    <td>{{ row.ward_name }}</td>
                    <td>{{ row.reference }}</td>
                    <td>{{ row.grade_code }}</td>
                    <td><a :href="'/members/' + row.member_id" target="_blank">{{ row.forename }} {{ row.surname  }}</a></td>
                    <td>{{ row.start_date }}</td>
                    <td>{{ row.start_time }} - {{ row.end_time }}</td>
                    <td>{{ row.booking_status_name }}</td>
                    
                </tr>
               
            </tbody>

        </table>

        <BookingLogsModel :showModal="showModal" @closeModal="closeModal" :booking_id="booking_id"/>

    </div>
</template>

<script>
import UtilityService from '@/services/UtilityService.js';
//import BookingService from '@/services/BookingService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

import BookingLogsModel from '@/components/Bookings/BookingLogsModel.vue';


export default {
    
      name: 'CancelledBookings',
        mixins: [MemberMixin],
        data: function () {
            return {
                   search: '',
                   bookings: [],
                   loading: false,
                   working:false,
                   showModal: false,
                   assigned:false,
                   alertText: '',
                   members: [],
                   booking_id: '',
                   start_date: '',
                   end_date: ''
                   
            }
        },
        components: {
            BookingLogsModel,
            
        },
        methods: {
            showLogsModal(booking_id) {
                this.booking_id = booking_id
                this.showModal = true
                
            },
            getStartDate() {
                var d = new Date();
                d.setDate(d.getDate() - 30);
                return d.toISOString().slice(0,10);
            },
            getEndDate() {
                var d = new Date();
                d.setDate(d.getDate() + 365);
                return d.toISOString().slice(0,10);
            },
            
            async getBookings() {
                this.loading=true
                UtilityService.getSimpleApiData(this.accessToken, "bookings/cancelled?start_date=" + this.start_date + "&end_date=" + this.end_date)
                .then(
                    (bookings => {
                        this.$set(this, "bookings", bookings);
                        this.loading=false;
                        this.working = false;
                    }).bind(this)
                ).catch((error) => {
                    if (error && error.response && error.response.status === 401) {
                        this.loading = false;
                        this.working = false;
                        return;
                    }

                    this.loading = false;
                    this.working = false;
                });
            },
            
           
            
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                if(this.accessToken) {
                    this.getBookings();
                }
            });
        
        },
        watch: {
            start_date: function () {
            localStorage.bookings_start_date = this.start_date;
            if(this.accessToken != '')
                {
                this.bookings = []
                this.getBookings();
                }
            },
            end_date: function () {
            localStorage.bookings_end_date = this.end_date;
            if(this.accessToken != '')
                {
                    this.bookings = []
                this.getBookings();
                }
            },
        
        },
        mounted() {
            if (localStorage.bookings_start_date) {
                this.start_date = localStorage.bookings_start_date;
            }
            else{
                this.start_date = this.getStartDate()
            }

            if (localStorage.bookings_end_date) {
                this.end_date = localStorage.bookings_end_date;
            }
            else{
             this.end_date =this.getEndDate()
            }

           
            
        },
        computed : {
            filtered_bookings: function () {
            
                let filtered_bookings =  this.bookings

                if(this.search != '' && this.search != null)
                {
                    filtered_bookings = filtered_bookings.filter(
                        row => (row.forename != null && row.forename.toLowerCase().includes(this.search.toLowerCase() ) ) 
                        || (row.surname != null && row.surname.toLowerCase().includes(this.search.toLowerCase() )) 
                        || (row.reference != null && row.reference.toLowerCase().includes(this.search.toLowerCase() )) 
                        || (row.client_name != null && row.client_name.toLowerCase().includes(this.search.toLowerCase() ) )
                        || (row.id.toString() != null && row.id.toString().toLowerCase().includes(this.search.toLowerCase() ) )
                    )
                }
                return filtered_bookings
            },
        },
    }
</script>